// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("core.ruffle." + {"110":"657e899f902c4ad69b3a","993":"8b146054009d1904410a"}[chunkId] + ".js");